export default __webpack_public_path__ + "static/media/image2.d92a1dc5.jpg";